import React from "react"
import { getMediaFor, MEDIA_BREAKPOINT_KEYS } from "style/style_snippets"
import Grid from "@mui/material/Grid"
import Container from "@mui/material/Container"
import PropTypes from "prop-types"
import { navigate } from "gatsby"
import { Typography } from "@mui/material"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import Button from "@mui/material/Button"
import TitleDescription from "components/shared/TitleDescription"

const HomeSectionWrapper = ({
  children,
  sectionTitle,
  sectionDescription,
  sectionButtonTitle,
  sectionButtonLink,
  sectionSubDescription,
}) => {
  const homeSectionWrapperStyle = {
    container: {
      ...getMediaFor("paddingBottom", 55, {
        [MEDIA_BREAKPOINT_KEYS.xs]: 65,
        [MEDIA_BREAKPOINT_KEYS.sm]: 75,
        [MEDIA_BREAKPOINT_KEYS.md]: 95,
      }),
    },
    titleDescription: {
      ...getMediaFor("marginBottom", "8px", {
        [MEDIA_BREAKPOINT_KEYS.xs]: "12px",
        [MEDIA_BREAKPOINT_KEYS.sm]: "16px",
        [MEDIA_BREAKPOINT_KEYS.md]: "20px",
      }),
    },
    sectionSubDescription: {
      ...getMediaFor("paddingBottom", 20, {
        [MEDIA_BREAKPOINT_KEYS.xs]: 25,
        [MEDIA_BREAKPOINT_KEYS.sm]: 35,
        [MEDIA_BREAKPOINT_KEYS.md]: 30,
      }),
    },

    miniDivider: {
      width: 50,
      borderBottom: "1px solid black",
      margin: "10px 0 20px 0px",
    },
  }

  return (
    <Container css={homeSectionWrapperStyle.container} maxWidth={"md"}>
      <TitleDescription
        {...{
          title: sectionTitle,
          description: sectionDescription,
          additionalCss: homeSectionWrapperStyle.titleDescription,
        }}
      />

      {sectionSubDescription && (
        <Typography
          variant={"body1"}
          css={homeSectionWrapperStyle.sectionSubDescription}
        >
          {sectionSubDescription}
        </Typography>
      )}

      <Grid container spacing={2}>
        {children}
      </Grid>

      <Button
        css={{ marginTop: "30px" }}
        onClick={() => navigate(sectionButtonLink)}
        startIcon={<ChevronRightIcon />}
        variant={"contained"}
        color={"primary"}
      >
        {sectionButtonTitle}
      </Button>
    </Container>
  )
}

HomeSectionWrapper.propTypes = {
  withBackgrounder: PropTypes.bool,
  sectionTitle: PropTypes.string.isRequired,
  sectionDescription: PropTypes.string.isRequired,
  sectionButtonTitle: PropTypes.string.isRequired,
  sectionButtonLink: PropTypes.string.isRequired,
}

export default HomeSectionWrapper
